import React from "react"
 
function CookiePolicy(props) {
  return (
    <section>

    
    <div className="container simple-page">
      <h1>Cookies Policy</h1>

<p>Last updated: November 07, 2018</p>

<p>To Meet App ("us", "we", or "our") uses cookies on the http://tomeetworkplace.com website and the To Meet App mobile application (the "Service"). By using the Service, you consent to the use of cookies.</p>

<p>Our Cookies Policy explains what cookies are, how we use cookies, how third-parties we may partner with may use cookies on the Service, your choices regarding cookies and further information about cookies.</p>

<h2>What are cookies</h2>

<p>Cookies are small pieces of text sent to your web browser by a website you visit. A cookie file is stored in your web browser and allows the Service or a third-party to recognize you and make your next visit easier and the Service more useful to you.</p>

<p>Cookies can be "persistent" or "session" cookies. Persistent cookies remain on your personal computer or mobile device when you go offline, while session cookies are deleted as soon as you close your web browser.</p>

<h2>How To Meet App uses cookies</h2>

<p>When you use and access the Service, we may place a number of cookies files in your web browser.</p>

<p>We use cookies for the following purposes:</p>

<ul>
<li>
    <p>To enable certain functions of the Service</p>
</li>
<li>
    <p>To provide analytics</p>
</li>
<li>
    <p>To store your preferences</p>
</li>
</ul>

<p>We use both session and persistent cookies on the Service and we use different types of cookies to run the Service:</p>

<ul>
<li>
    <p>Essential cookies. We may use cookies to remember information that changes the way the Service behaves or looks, such as a user's language preference on the Service.</p>
</li>
<li>
    <p>Accounts-related cookies. We may use accounts-related cookies to authenticate users and prevent fraudulent use of user accounts. We may use these cookies to remember information that changes the way the Service behaves or looks, such as the "remember me" functionality.</p>
</li>
<li>
    <p>Analytics cookies. We may use analytics cookies to track information how the Service is used so that we can make improvements. We may also use analytics cookies to test new advertisements, pages, features or new functionality of the Service to see how our users react to them.</p>
</li>
</ul>

<h2>Third-party cookies</h2>

<p>In addition to our own cookies, we may also use various third-parties cookies to report usage statistics of the Service, deliver advertisements on and through the Service, and so on.</p>

<h2>What are your choices regarding cookies</h2>

<p>If you'd like to delete cookies or instruct your web browser to delete or refuse cookies, please visit the help pages of your web browser.</p>

<p>Please note, however, that if you delete cookies or refuse to accept them, you might not be able to use all of the features we offer, you may not be able to store your preferences, and some of our pages might not display properly.</p>

<ul>
<li>
    <p>For the Chrome web browser, please visit this page from Google: <a href="https://support.google.com/accounts/answer/32050">https://support.google.com/accounts/answer/32050</a></p>
</li>
<li>
    <p>For the Internet Explorer web browser, please visit this page from Microsoft: <a href="http://support.microsoft.com/kb/278835">http://support.microsoft.com/kb/278835</a></p>
</li>
<li>
    <p>For the Firefox web browser, please visit this page from Mozilla: <a href="https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored">https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored</a></p>
</li>
<li>
    <p>For the Safari web browser, please visit this page from Apple: <a href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac">https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac</a></p>
</li>
<li>
    <p>For any other web browser, please visit your web browser's official web pages.</p>
</li>
</ul>

<h2>Where can you find more information about cookies</h2>

<p>You can learn more about cookies and the following third-party websites:</p>

<ul>
<li>
    <p>AllAboutCookies: <a href="http://www.allaboutcookies.org/">http://www.allaboutcookies.org/</a></p>
</li>
<li>
    <p>Network Advertising Initiative: <a href="http://www.networkadvertising.org/">http://www.networkadvertising.org/</a></p>
</li>
</ul>

    </div>
    </section>
  )
}
 
export default CookiePolicy;